import { Session } from './Session';
import { PeriodicFlushQueue } from "./PeriodicFlushQueue";

export const Tracker = {
    _USER: null,
    _lastEvent: null,
    _hideBound: false,
    onHide: () => {
        PeriodicFlushQueue.add( Tracker.formatEvent( 'hide-tab' , '' ) );
        PeriodicFlushQueue.flushNow()
    },
    onShow: () => {
        PeriodicFlushQueue.add( Tracker.formatEvent( 'show-tab' , '' ) );
    },
    useAPI: API => {
        PeriodicFlushQueue.useAPI( API );
    },
    forUser: user => {
        Tracker._USER = user;
    },
    start: () => {
        if ( ! Tracker._hideBound ) {
            document.addEventListener('visibilitychange', () => {
                if (document.visibilityState === 'hidden') Tracker.onHide();
                if (document.visibilityState === 'visible') Tracker.onShow();
            });
            Tracker._hideBound = true;
        }
        PeriodicFlushQueue.start();
    },
    stop: () => {
        PeriodicFlushQueue.stop();
    },
    pushEvent: ( event , screen , props = {} ) => {
        const candidateEvent = `${event.trim()}-${screen.trim()}`;
        if( Tracker._lastEvent !== candidateEvent && Tracker._USER ) {
            Tracker._lastEvent = candidateEvent;
            PeriodicFlushQueue.add( Tracker.formatEvent( event , screen , props ) );
        }
    },
    formatEvent: ( event , screen , props = {} ) => {
        return {
            timestamp: new Date().toISOString(),
            event: event,
            screen: screen,
            sessionId: Session.getId(),
            userId: Tracker._USER?.id,
            userEmail: Tracker._USER?.username,
            userIdentity: Tracker._USER?.label,
            accountId: Tracker._USER?.accountId,
            accountName: Tracker._USER?.accountLabel,
            props: JSON.stringify( props )
        };
    }
}
